import { triggerMergeCartOnLogin } from 'src/scripts/utils/cart/cart-apis';
import '../../../styles/templates/customers/account.scss';
import './account/runShopByColor';
import { initPickupStatusForOrderItems } from '../PickupItemStatus';
(async function () {
  if (!document.referrer.includes('aloyoga.com')) {
    var returnUrl = window.sessionStorage.getItem('social-login-return-url');
    if (returnUrl) {
      await triggerMergeCartOnLogin();
      window.sessionStorage.removeItem('social-login-return-url');
      if (returnUrl === '/account') return;

      // ? why can this not just be the `returnUrl`
      // - in the interim we will do the following check
      let redirectUrl = returnUrl.includes(window.location.origin)
        ? returnUrl
        : window.location.origin +
          // ? is this need given we checking for the origin above?
          (returnUrl[0] === '/' ? returnUrl : '/' + returnUrl); // XXS protection

      window.location.href = redirectUrl;
    }
  }
})();

initPickupStatusForOrderItems();
